export const baseUrl = 'https://api-betatestnet.brine.finance/salt/api';
